// Datadog RUM is loaded by the `datadog_rum` partial, which only renders when
// DATADOG_RUM_CLIENT_TOKEN and DATADOG_RUM_APPLICATION_ID are set. Where they
// aren't, window.DD_RUM is undefined and reporting is a no-op.
//
// Noise filtering ('Illegal invocation', Facebook's in-app browser) lives in the
// partial's beforeSend, since RUM only accepts filters at init time.
//
// Named notifyError rather than reportError to avoid shadowing window.reportError,
// which would silently swallow reports if an import were ever dropped.
export function notifyError(error: unknown, context?: Record<string, unknown>) {
  if(typeof window === 'undefined' || !window.DD_RUM) { return }

  window.DD_RUM.onReady(() => {
    window.DD_RUM?.addError(error, context)
  })
}

export default notifyError
